/** The "veya" rule between the Telegram button and the email form. */
export function AuthDivider() {
  return (
    <div className="flex items-center gap-3" aria-hidden>
      <span className="h-px flex-1 bg-surface-800" />
      <span className="text-xs uppercase tracking-widest text-surface-600">veya</span>
      <span className="h-px flex-1 bg-surface-800" />
    </div>
  );
}

interface AuthSwitchProps {
  question: string;
  action: string;
  onClick: () => void;
}

/**
 * Moves between the dialog's tabs.
 *
 * A button, not a link: switching tabs changes nothing about the address, and a
 * link that does not navigate is one a middle-click opens into a broken page.
 */
export function AuthSwitch({ question, action, onClick }: AuthSwitchProps) {
  return (
    <p className="text-center text-sm text-surface-500">
      {question ? `${question} ` : null}
      <button
        type="button"
        onClick={onClick}
        className="font-medium text-brand-400 transition hover:text-brand-300"
      >
        {action}
      </button>
    </p>
  );
}
